import React, { useState } from 'react';
import { DownOutlined, FilterFilled } from '@ant-design/icons';
import {
  Card,
  Progress,
  Tag,
  Row,
  Col,
  Select,
  Button,
  Switch,
  Drawer,
  Menu,
  Dropdown,
  Input,
  Tabs,
  Popover,
  Divider,
  Spin,
  DatePicker,
  Checkbox,
} from 'antd';
import moment from 'moment';
import { FormattedMessage, formatMessage } from 'umi-plugin-react/locale';
import _ from 'underscore';
import FiltersConstants from '../FiltersConstants';
import styles from './index.less';
import { getHistoricalDate } from '../../../utils/getHistoricalDate';
import AllServices from '../../../../config/AllServices';

const { Meta } = Card;
const { TabPane } = Tabs;
const { Search } = Input;
const { Option } = Select;

function RenderFilters(props) {
  const [show, setShow] = useState(false);

  function showComp() {
    setShow(show ? false : true);
  }

  let {
    allCloudAccountsList,
    handleCheckbox,
    appliedFilters,
    selectedCloudAccounts,
    handleHistoryChange,
    selectedDate,
    propSelectedDate,
  } = props;

  if (propSelectedDate) {
    let filterDate = moment(new Date(propSelectedDate.endTime)).format('YYYY-MM-DD');

    let todayDate = moment(new Date()).format('YYYY-MM-DD');

    if (filterDate === 'Invalid date') {
    } else {
      if (todayDate === filterDate) {
        selectedDate = 'Select Date';
      } else {
        selectedDate = filterDate;
      }
    }
  }

  let filtersFields = [...FiltersConstants];

  let cloneAccounts = allCloudAccountsList.map(v => {
    return {
      value: v.id,
      checked: false,
    };
  });

  let cloudAccountCategory = {
    type: 'cloudAccounts',
    label: 'Cloud Accounts',
    values: cloneAccounts,
    orderOfDisplay: 0,
  };

  filtersFields.push(cloudAccountCategory);
  filtersFields = filtersFields.sort(function(a, b) {
    if (a.orderOfDisplay < b.orderOfDisplay) {
      return -1;
    }
    if (a.orderOfDisplay > b.orderOfDisplay) {
      return 1;
    }
    return 0;
  });

  let menu = (filterObj, mainIndex) => {
    let currentType = filterObj.type;

    let azure = AllServices.AZURE.map(s => s.key);
    let aws = ['EC2', ...AllServices.AWS.filter(e => !e.key.includes('EC2:')).map(s => s.key)];
    let gcp = AllServices.GCP.map(s => s.key);

    return (
      <Menu
        key={Math.random(87999)}
        style={{
          maxHeight: 480,
          overflow: 'auto',
        }}
      >
        {filterObj.values.map((valueObj, subIndex) => {
          let icon = '';
          let isAzure = azure.find(v => valueObj.value === v);
          let isAws = aws.find(v => valueObj.value === v);
          let isGcp = gcp.find(v => valueObj.value === v);

          if (isAzure) {
            icon = <img src="/azure@2x.png" alt="azure" style={{ height: 12, marginLeft: 7 }} />;
          }
          if (isAws) {
            icon = <img src="/awslogo.png" alt="aws" style={{ height: 18, marginBottom: '3px' }} />;
          }
          if (isGcp) {
            icon = <img src="/gcplogo.png" alt="gcp" style={{ height: 20, marginBottom: '3px' }} />;
          }
          let currentFilter = appliedFilters.find(v => v.type === currentType);
          let isChecked = false;
          if (currentFilter) {
            let isMatched = currentFilter.value.find(v => v === valueObj.value);
            isChecked = isMatched ? true : false;
          }
          if (filterObj.type === 'cloudAccounts') {
            let currentAcc = allCloudAccountsList.filter(account => account.id === valueObj.value);
            return (
              <Menu.Item key={Math.random(87999)}>
                <Checkbox
                  checked={isChecked}
                  onChange={e => handleCheckbox(e, filterObj, mainIndex, subIndex)}
                  style={{ color: 'grey', marginTop: '7px' }}
                  value={valueObj.value}
                >
                  {currentAcc[0].accountName}
                  {currentAcc[0].provider === 'AWS' ? (
                    <img src="/awslogo.png" alt="aws" style={{ height: 18, marginBottom: '3px' }} />
                  ) : currentAcc[0].provider === 'AZURE' ? (
                    <img src="/azure@2x.png" alt="azure" style={{ height: 12, marginLeft: 7 }} />
                  ) : (
                    <img src="/gcplogo.png" alt="gcp" style={{ height: 20, marginLeft: -4 }} />
                  )}
                </Checkbox>
              </Menu.Item>
            );
          } else {
            if (valueObj.value === 'EC2') {
              let ec2Components = [
                'EC2:Instance',
                'EC2:Volume',
                'EC2:ElasticIP',
                'EC2:RI',
                'EC2:SecurityGroups',
                'EC2:SnapShot',
              ];
              let service = appliedFilters.filter(val => val.type === 'service');
              if (service && service.length > 0) {
                var serVal = service[0].value;
                var arrContain = _.intersection(ec2Components, serVal);
              }
              let obj = {
                type: 'service',
                values: ec2Components,
              };
              let content = (
                <div>
                  {ec2Components.map(val => {
                    let obj = {
                      type: 'service',
                      values: ec2Components,
                    };
                    return (
                      <div key={Math.random(87999)} style={{ marginTop: '6px' }}>
                        <Checkbox
                          checked={serVal && serVal.includes(val)}
                          onChange={e => handleCheckbox(e, obj, mainIndex)}
                          value={val}
                          style={{ color: 'grey' }}
                        >
                          {AllServices.getFullName(val)}
                        </Checkbox>
                      </div>
                    );
                  })}
                </div>
              );

              return (
                <div key={Math.random(87999)}>
                  <Popover placement="leftTop" content={content}>
                    <div
                      style={{
                        marginLeft: '12px',
                        marginTop: '15px',
                        cursor: 'pointer',
                        color: 'grey',
                      }}
                      onClick={showComp}
                    >
                      {filterObj.type === 'service' ? (
                        <Checkbox
                          indeterminate={
                            arrContain && arrContain.length < 6 && arrContain.length > 0
                              ? true
                              : false
                          }
                          checked={arrContain && arrContain.length === 6}
                          style={{ color: 'grey' }}
                          value="EC2"
                          onChange={e => handleCheckbox(e, obj, mainIndex)}
                        >
                          {formatMessage({
                            id: 'component.Tag.' + `${valueObj.value}`,
                          })}
                        </Checkbox>
                      ) : (
                        valueObj.value
                      )}
                      {icon && icon}
                      <DownOutlined style={{ cursor: 'pointer' }} onClick={showComp} />
                    </div>
                  </Popover>
                </div>
              );
            } else {
              return (
                <Menu.Item key={Math.random(87999)}>
                  <Checkbox
                    checked={isChecked}
                    onChange={e => handleCheckbox(e, filterObj, mainIndex, subIndex)}
                    style={{ color: 'grey', marginTop: '7px' }}
                    value={valueObj.value}
                  >
                    {filterObj.type === 'service'
                      ? AllServices.getFullName(valueObj.value)
                      : valueObj.value}
                    {(filterObj.type === 'service' && icon) || ''}
                  </Checkbox>
                </Menu.Item>
              );
            }
          }
        })}
      </Menu>
    );
  };

  let calendarValue = selectedDate !== 'Select Date' && moment(selectedDate);

  return (
    <div>
      <Row type="flex">
        <Col span={3} style={{ marginTop: 4 }}>
          <FilterFilled style={{ marginLeft: '24px' }} />
          <p style={{ display: 'inline-block', marginLeft: 6, fontWeight: 'bold', fontSize: 15 }}>
            Filter by
          </p>
        </Col>
        <Col span={21}>
          <div style={{ float: 'right', marginRight: '-6px' }}>
            {filtersFields.map((filterObj, mainIndex) => {
              return (
                <Dropdown
                  key={Math.random(87999)}
                  // key={Math.random(87999)}
                  overlay={menu(filterObj, mainIndex)}
                >
                  <span
                    style={{
                      color: 'rgba(0, 0, 0, 0.45)',
                      fontSize: 15,
                      marginLeft: 10,
                      textDecoration: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {filterObj.label} <DownOutlined />
                  </span>
                </Dropdown>
              );
            })}
            <div
              style={{
                display: 'inline',
                marginLeft: '10px'
              }}
            >
              {calendarValue ? (
                <DatePicker
                  className={styles.dateSelector}
                  style={{ width: 112 }}
                  placeholder={selectedDate}
                  allowClear={false}
                  value={calendarValue && calendarValue}
                  suffixIcon={
                    <DownOutlined
                      style={{ marginTop: -4, fontSize: 11, color: 'rgba(0, 0, 0, 0.45)' }}
                    />
                  }
                  disabledDate={current => current && current > moment().endOf('day')}
                  onChange={e => {
                    handleHistoryChange(e);
                  }}
                />
              ) : (
                <DatePicker
                  className={styles.dateSelector}
                  style={{ width: 112 }}
                  placeholder={selectedDate}
                  allowClear={false}
                  suffixIcon={
                    <DownOutlined
                      style={{ marginTop: -4, fontSize: 11, color: 'rgba(0, 0, 0, 0.45)' }}
                    />
                  }
                  disabledDate={current => current && current > moment().endOf('day')}
                  onChange={e => {
                    handleHistoryChange(e);
                  }}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
      <Divider style={{ margin: '0px 0' }} />
    </div>
  );
}

export default RenderFilters;
